import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { Image, Button } from "react-bootstrap";
import { MESSAGE } from '../../../utils/message';
import DollarPrice from '../../../components/common/dollarPrice';
import NoImage from "../../../assests/images/gnp_noimg.png"
import UsdDonate from '../../../components/common/commonUsdDonate/UsdDonate';
import ArrowIcon from '../../../assests/images/arrow-right.svg';
import {
  SearchBanner,
  LeftBanner,
  LogoTitle,
  LogoImage,
  TitleSection,
  SearchTitle,
  AdoptionsList,
  IconSpan,
  AdoptionsItem,
  ReviewStart,
  ButtonSection,
  WarmCost,
  WarmCostLeft,
  WarmCoastTile,
  SmallText,
  DollarWrapper,
  WarnCostRight,
  RightBanner,
} from "./searchBannerBoxStyle"
import RatingStar from "../ratingStar/ratingStar";
import DonateNowModal from '../../common/modal/donateNowModal';

const SearchBannerBox = ({ campDetails, editDonateNowOpen, setDonateNowOpen, donationAmount, formik, imageSlider, id }: any) => {

  const user_id = typeof localStorage !== "undefined" && localStorage.getItem("userId");
  const navigate = useNavigate();
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  };
  // const handleClick = () => {
  //   if (typeof localStorage !== "undefined" && localStorage?.getItem("token")) {
  //     if (campDetails?.can_review) {
  //       navigate(`/write-review/${id}`, { state: { title: campDetails?.title } });
  //     } else {
  //       navigate(`/users/profile/${user_id}`)
  //     }
  //   } else {
  //     typeof localStorage !== "undefined" && localStorage.setItem('reviewPath', `/write-review/${id}`);
  //     navigate(`/signin`);
  //   }
  // };
  const handleClick = () => {
    if (typeof localStorage !== "undefined" && localStorage?.getItem("token")) {
      if (campDetails?.can_review) {
        navigate(`/write-review/${id}`, { state: { title: campDetails?.title } });
      } else {
        navigate(`/users/profile/${user_id}`);
      }
    } else {
      navigate(`/write-review/${id}`, { state: { title: campDetails?.title } });
      // if (typeof localStorage !== "undefined") {
      //   localStorage.setItem('redirectAfterLogin', `/write-review/${id}`);
      // }
      // navigate(`/signin`, { replace: true });
      // window.location.href = "/signin"; 
    }
  };


  return (
    <>
      <SearchBanner className="search-banner-view">
        <LeftBanner>
          <LogoTitle>
            <LogoImage>
              <Image src={campDetails?.logo || NoImage} alt="MlseFoundationLogo" />
            </LogoImage>
            <TitleSection>
              <SearchTitle>{campDetails?.title}</SearchTitle>
              <AdoptionsList>
                <AdoptionsItem onClick={() => navigate(`/state/${campDetails?.state}`)}>
                  {campDetails?.state}
                  <IconSpan
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Image src={ArrowIcon} alt="ArrowIcon" />
                  </IconSpan>
                </AdoptionsItem>

                <AdoptionsItem
                  onClick={() =>
                    navigate(`/city/${campDetails?.city}/${campDetails?.stateSlug}`, {
                      state: { stateFullName: campDetails?.statel, zipcodeAdd: campDetails?.zipcode },
                    })
                  }
                >
                  {campDetails?.city}
                  <IconSpan
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Image src={ArrowIcon} alt="ArrowIcon" />
                  </IconSpan>
                </AdoptionsItem>

                {campDetails?.causes?.length > 0 && (
                  <AdoptionsItem
                    onClick={() =>
                      navigate(`/city/${campDetails?.city}/${campDetails?.stateSlug}/category:${campDetails?.causes[0]?.slug}/sort:review_count/direction:desc`)
                    }
                  >
                    {campDetails?.causes[0]?.title}
                  </AdoptionsItem>
                )}
              </AdoptionsList>


              <ReviewStart>
                <RatingStar review={campDetails?.review_count} rating={campDetails?.rating} />
              </ReviewStart>
            </TitleSection>
          </LogoTitle>
          <ButtonSection>
            <Button className="write-yellow-btn" onClick={() => scrollToSection("read-stories")}>{MESSAGE.readStories}</Button>
            <Button className="btn-outline-success-blue" onClick={handleClick}>{MESSAGE.shareYourStory}</Button>
            {campDetails?.is_donation_enable && <Button className="donate-now-btn share_donate_btn" onClick={() => setDonateNowOpen(true)}>{MESSAGE.donateNowBtn}</Button>}
          </ButtonSection>
          {campDetails?.is_donation_enable && <WarmCost className="warm-cost-wrapper">
            <WarmCostLeft>
              <WarmCoastTile>{`Support ${campDetails?.title}`}</WarmCoastTile>
              <SmallText>{MESSAGE.supportOneWarmCoatDescription}</SmallText>
              <DollarWrapper >
                <DollarPrice donationAmount={donationAmount} formik={formik} />
              </DollarWrapper>
            </WarmCostLeft>
            <WarnCostRight>
              <UsdDonate formik={formik} />
            </WarnCostRight>
          </WarmCost>}
        </LeftBanner>
        {(imageSlider && campDetails?.images?.length > 0) && <RightBanner className="slider-banner">
          {imageSlider && <ImageGallery useBrowserFullscreen={false} showBullets={false} showPlayButton={false} autoPlay={false} items={campDetails ? campDetails?.images : []} />}
        </RightBanner>}
      </SearchBanner>
      <DonateNowModal metadata={{ title: campDetails?.title || "" }} editDonateNowOpen={editDonateNowOpen} setDonateNowOpen={setDonateNowOpen} donationAmount={donationAmount} formik={formik} />
    </>

  )
};
export default SearchBannerBox;